import { createBrowserRouter, Navigate } from 'react-router-dom'
import { AdminLayout } from './layouts/AdminLayout'
import { AdminProtectedRoute } from './components/AdminProtectedRoute'

import AdminLoginPage from './pages/admin/AdminLoginPage'
import AdminOverviewPage from './pages/admin/AdminOverviewPage'
import AdminTenantsPage from './pages/admin/AdminTenantsPage'
import AdminBillingPage from './pages/admin/AdminBillingPage'
import AdminAdminsPage from './pages/admin/AdminAdminsPage'
import AdminExchangeRatesPage from './pages/admin/AdminExchangeRatesPage'
import AdminAppUpdatesPage from './pages/admin/AdminAppUpdatesPage'

/**
 * The `admin` app is now SaaS-platform-only. All non-admin routes redirect
 * users back to the admin login. Tenant customers (admin / user / driver /
 * viewer) live in the separate `app/` frontend on port 3001.
 */
export const router = createBrowserRouter([
  {
    path: '/admin/login',
    element: <AdminLoginPage />,
  },
  {
    path: '/admin',
    element: (
      <AdminProtectedRoute>
        <AdminLayout />
      </AdminProtectedRoute>
    ),
    children: [
      { index: true, element: <Navigate to="/admin/dashboard" replace /> },
      { path: 'dashboard', element: <AdminOverviewPage /> },
      { path: 'tenants',   element: <AdminTenantsPage /> },
      { path: 'billing',   element: <AdminBillingPage /> },
      { path: 'admins',    element: <AdminAdminsPage /> },
      { path: 'exchange-rates',  element: <AdminExchangeRatesPage /> },
      { path: 'app-updates',     element: <AdminAppUpdatesPage /> },
    ],
  },

  { path: '/', element: <Navigate to="/admin/login" replace /> },
  { path: '*', element: <Navigate to="/admin/login" replace /> },
])
